import React from 'react'
import facebook from './svgs/deleteIcon.svg'
import { BaseIcon } from './_base'

export const DeleteIcon = ({ size, fontSize, sx }) => {
    return (
        <BaseIcon icon={facebook} {...{ fontSize, size, ...sx }} />
    )
}
